var _rect, _circle, _path, _path2, _path3, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconVideo = function SvgIconVideo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.42969,
    y: 6.29999,
    width: 43.1413,
    height: 32.5957,
    rx: 3.14239,
    fill: "#DFDFDF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.4794,
    cy: 22.5978,
    r: 6.71087,
    fill: "#48A9A6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3145 22.5979L21.5623 25.9189L21.5623 19.2769L27.3145 22.5979Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9079 6.29999C43.6434 6.29999 45.0503 7.70688 45.0503 9.44238L45.0503 35.7532C45.0503 37.4887 43.6434 38.8956 41.9079 38.8956L37.8601 38.8956L37.8601 6.29999L41.9079 6.29999Z",
    fill: "#87CBC8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.14062 6.29999L8.14062 38.8956L4.0928 38.8956C2.3573 38.8956 0.950406 37.4887 0.950406 35.7532L0.950407 9.44238C0.950407 7.70689 2.3573 6.29999 4.0928 6.29999L8.14062 6.29999Z",
    fill: "#87CBC8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.86768,
    y: 12.0522,
    width: 3.35543,
    height: 4.79348,
    rx: 0.628478,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 39.7773,
    y: 12.0522,
    width: 3.35544,
    height: 4.79348,
    rx: 0.628478,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2.86768,
    y: 20.6805,
    width: 3.35543,
    height: 4.79348,
    rx: 0.628478,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 39.7773,
    y: 20.6805,
    width: 3.35544,
    height: 4.79348,
    rx: 0.628478,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 2.86768,
    y: 29.3087,
    width: 3.35543,
    height: 4.79348,
    rx: 0.628478,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 39.7773,
    y: 29.3087,
    width: 3.35544,
    height: 4.79348,
    rx: 0.628478,
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconVideo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "apps/static/media/icon-video.21613a557d2f9d415096168b1cefcb7e.blank.svg";